import React from "react";

import LandingLayout from "../components/layouts/LandingLayout";

import AboutUs from "../components/sections/AboutUs";
import Anniversary from "../components/sections/Anniversary";
import Contacts from "../components/sections/Contacts";
import Internship from "../components/sections/Internship";
import Services from "../components/sections/Services";
import Slider from "../components/sections/Slider";
import Team from "../components/sections/Team";
import Projects from "../components/sections/Projects";
import Partners from "../components/sections/Partners";

export default function Landing() {
  return ( <LandingLayout>
    <>
      <Slider />
      <Services />
      <AboutUs/>
      <Team/>
      <Projects/>
      <Anniversary />
      <Partners/>
      <Internship />
      <Contacts />
    </>
    </LandingLayout>
  );
}
